const ACTION_PREFIX = 'LANGUAGE_SWITCHER';

export const STATE_NAME = 'languageSwitcher';

export const Actions = {
  CHANGE_LANGUAGE_START: `${ACTION_PREFIX}/CHANGE_LANGUAGE_START`,
  CHANGE_LANGUAGE_SUCCESS: `${ACTION_PREFIX}/CHANGE_LANGUAGE_SUCCESS`,
  CHANGE_LANGUAGE_FAIL: `${ACTION_PREFIX}/CHANGE_LANGUAGE_FAIL`,
};
